<template>
  <section class="header-edit modal-backdrop">
    <div class="modal-container standard-size">
      <!-- Header -->
      <div class="modal-container__header">
        <h2 class="h1">EDIT HEADER</h2>
        <div style="cursor: pointer" @click="close()">
          <v-icon name="times" scale="2" />
        </div>
      </div>

      <!-- Language Container -->
      <language-adaptive-select
        v-if="!$isSingleLanguage"
        @change="toggleLanguage"
        :languageTypes="languageTypes"
        :localLanguageTypesIndex="localLanguageTypesIndex"
      />
      <!-- Visibility -->
      <!-- <div class="input-group">
        <h3 class="h2">Visibility</h3>

        <h4 class="input-label-lookalike">
          Which Guests should the header be visible to?
        </h4>
        <div class="horizontal-checkbox">
          <label class="input-checkbox"
            >Pre-checked in
            <input type="checkbox" v-model="visibility.precheckin" />
            <span class="checkbox-button"
              ><v-icon class="check-icon" name="check" scale="0.9"
            /></span>
          </label>
          <label class="input-checkbox"
            >Checked in
            <input type="checkbox" v-model="visibility.checkin" />
            <span class="checkbox-button"
              ><v-icon class="check-icon" name="check" scale="0.9"
            /></span>
          </label>
          <label class="input-checkbox"
            >Guests from QR code
            <input type="checkbox" v-model="visibility.anonymous" />
            <span class="checkbox-button"
              ><v-icon class="check-icon" name="check" scale="0.9"
            /></span>
          </label>
        </div>
      </div> -->

      <!-- Personal Greeting -->
      <!-- <div class="input-group">
        <h3 class="h2">Personal Greeting</h3>
        <label class="input-switch add--margin-bottom"
          >Show Personal Greeting in the Top Bar?
          <input type="checkbox" v-model="isPersonalGreetingVisible" />
          <span class="switch-button"></span>
        </label>
      </div> -->

      <!-- Welcome Message -->
      <div class="input-group">
        <h3 class="h2">Welcome Message</h3>
        <HtmlEditor
          v-for="languageIndex in languageIndeces" 
          :key="languageIndex"
          v-show="languageIndex == localLanguageTypesIndex"
          v-model="contents[languageIndex]" 
        />
      </div>

      <!-- Colors -->
      <div class="input-group">
        <h3 class="h2 colorPickerWrapper">
          Colors
          <div v-if="showBackgroundPicker" class="colorOuterWrap">
            <div class="colorInnerWrap">
              <chrome-picker v-model="colors[activeColorPicker]" />
              <button
                class="color-picker-button"
                v-on:click="closeColorPicker()"
              >
                Select
              </button>
              <button
                class="closeBtn color-picker-button"
                v-on:click="closeColorPicker()"
              >
                Close
              </button>
            </div>
          </div>
        </h3>

        <div
          class="color-input-wrapper"
          @click="showColorPicker('backgroundColor')"
        >
          <GlobalInputTextfield
            label="Background Color"
            inputId="backgroundColor"
            v-model="backgroundColor.hex"
            maxlength="7"
          />
          <div
            class="color-indicator"
            :style="{ backgroundColor: backgroundColor.hex }"
          ></div>
        </div>
        <div class="color-input-wrapper" @click="showColorPicker('textColor')">
          <GlobalInputTextfield
            label="Text Color"
            inputId="textColor"
            v-model="textColor.hex"
            maxlength="7"
          />
          <div
            class="color-indicator"
            :style="{ backgroundColor: textColor.hex }"
          ></div>
        </div>
      </div>

      <!-- Header image or video -->
      <div class="input-group">
        <h3 class="h2">Header Image or Video</h3>

        <div class="icon-image-container">
          <div class="icon-image-container__radio-container">
            <button
              v-if="imageTab === 'IMAGE'"
              class="button-neutral"
              @click="showImageModal = true"
            >
              Choose Image
            </button>
            <button
              v-if="imageTab === 'VIDEO'"
              class="button-neutral"
              @click="showVideoInput = true"
            >
              Choose Video
            </button>
            <ImageManager
              v-if="showImageModal"
              :isModal="true"
              @changed="onSelectedImage"
              @close="showImageModal = false"
            />
            <video-insert-input v-if="showVideoInput"></video-insert-input>
            <label class="input-radio"
              >Image
              <input type="radio" value="IMAGE" v-model="imageTab" />
              <span class="radio-button"></span>
            </label>
            <label class="input-radio"
              >Video
              <input type="radio" value="VIDEO" v-model="imageTab" />
              <span class="radio-button"></span>
            </label>
          </div>
          <div v-if="imageTab === 'IMAGE'" class="icon-image-container__image">
            <img :src="imagePath" />
          </div>
          <div
            v-else-if="imageTab === 'VIDEO'"
            class="icon-image-container__video"
          >
            <!-- <v-icon name="brands/youtube" scale="5" style="color: var(--grey);"/> -->
            <iframe
              :src="videoPath"
              frameborder="0"
              webkitallowfullscreen
              mozallowfullscreen
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>

      <!-- Button Container -->
      <div class="button-container">
        <button class="button-neutral" @click="close()">Cancel</button>
        <button class="button-positive" @click="btnUpdate()">Save</button>
      </div>
    </div>
  </section>
</template>

<script>
import { db } from "@/firebase";
import { Sketch } from "vue-color";
import ImageManager from "@/components/MediaPage/MediaImages";
import GlobalInputTextfield from "@/components/GlobalComponents/GlobalInputTextfield";
import VideoInsertInput from "@/components/GlobalComponents/VideoInsertInput";
import newLanguageTypesFormatMixin from "@/mixins/newLanguageTypesFormatMixin";
import HtmlEditor from "@/components/GlobalComponents/HtmlEditor";
import bus from "@/bus.js";
import LanguageAdaptiveSelect from '@/components/Ui/LanguageAdaptiveSelect';

export default {
  components: {
    "chrome-picker": Sketch,
    HtmlEditor,
    ImageManager,
    GlobalInputTextfield,
    VideoInsertInput,
    LanguageAdaptiveSelect
  },
  mixins: [newLanguageTypesFormatMixin],
  data() {
    return {
      contents: [],
      backgroundColor: {
        hex: "#FFFFFF",
      },
      textColor: {
        hex: "#000000",
      },
      colors: {
        backgroundColor: {
          hex: "#FFFFFF",
        },
        textColor: {
          hex: "#000000",
        },
      },
      showBackgroundPicker: false,
      activeColorPicker: "",
      imageTab: "",
      videoPath: "",
      imagePath: "",
      showImageModal: false,
      showVideoInput: false,
      visibility: { precheckin: true, checkin: true, anonymous: true },
      localLanguageTypesIndex: 0,
      languageIndeces: [],
      languageTypes: [],
      // isVisible: true,
      isPersonalGreetingVisible: true,

      includeName: false,
      includeRoom: false,
    };
  },
  computed: {
    secondLanguage() {
      return (
        !this.$isSingleLanguage &&
        this.selectedLanguage === this.$settingsSecondLanguageType
      );
    },
    orderedArray: function () {
      let p = this.visibility.precheckin;
      let c = this.visibility.checkin;
      let a = this.visibility.anonymous;
      let orderedVisibility = { precheckin: p, checkin: c, anonymous: a };
      return orderedVisibility;
    },
  },
  firebase() {
    return {
      returnedData: {
        source: db.ref(`hotels/${this.$customerId}/${this.$hotelId}/headerContent/`),
        asObject: true,
        readyCallback: function (data) {
          this.contents = data.val().contents;
          this.backgroundColor.hex = data.val().backgroundColor;
          this.textColor.hex =
            data.val().textColor || this.getCorrectTextColor();
          this.colors.backgroundColor = this.backgroundColor.hex;
          this.colors.textColor = this.textColor.hex;

          this.visibility.precheckin = data.val().visibility.precheckin;
          this.visibility.checkin = data.val().visibility.checkin;
          this.visibility.anonymous = data.val().visibility.anonymous;

          this.isPersonalGreetingVisible =
            data.val().includeName || data.val().includeRoom; 

          if (data.val().videoPath) {
            this.videoPath = data.val().videoPath;
          }
          if (data.val().imageActive) {
            this.imageTab = "IMAGE";
          } else {
            this.imageTab = "VIDEO";
          }

          if (data.val().imagePath) {
            this.imagePath = data.val().imagePath;
          }
        },
      }
    };
  }, //End of Firebase
  async created() {
    this.localLanguageTypesIndex = await this._getLanguageIndex();
    this.languageTypes = await this._getCorrectEventLanguages();
    this.languageIndeces = new Array(this.languageTypes.length).fill().map((d,i)=>i);

    bus.$on("closeVideoModal", () => (this.showVideoInput = false));
    bus.$on("insertVideo", (properUrl) => {
      this.videoPath = properUrl;
      this.showVideoInput = false;
    });
  },
  watch: {
    colors: {
      deep: true,
      handler() {
        if (this.activeColorPicker == "backgroundColor") {
          this.backgroundColor.hex = this.colors[this.activeColorPicker].hex;
        } else if (this.activeColorPicker == "textColor") {
          this.textColor.hex = this.colors[this.activeColorPicker].hex;
        }
      },
    },
  },
  methods: {
    btnUpdate: function () {
      let headerContent = {
        contents: this.contents,
        backgroundColor: this.backgroundColor.hex,
        textColor: this.textColor.hex,
        imageActive: this.imageTab === "IMAGE" ? true : false,
        imagePath: this.imagePath,
        videoPath: this.videoPath,
        includeName: this.isPersonalGreetingVisible,
        includeRoom: this.isPersonalGreetingVisible,
        visibility: {
          precheckin: this.visibility.precheckin,
          checkin: this.visibility.checkin,
          anonymous: this.visibility.anonymous,
        },
        isPersonalGreetingVisible: this.isPersonalGreetingVisible,
      };
      db.ref(`hotels/${this.$customerId}/${this.$hotelId}/headerContent/`)
        .update(headerContent)
        .then(() => {
          this.$toastEvents.push({
            type: "positive",
            title: "Success",
            content: "The header has been updated",
            id: +new Date(),
          });
          this.$emit("close");
        });
    },
    closeModal() {
      this.showBackgroundPicker = false;
    },
    closeColorPicker() {
      this.showBackgroundPicker = false;
    },
    showColorPicker(activeColor) {
      this.showBackgroundPicker = true;
      this.activeColorPicker = activeColor;
    },
    changeEditorBackground(editor) {
      if (editor.getBody().style.backgroundColor) {
        editor.getBody().removeAttribute("style");
      } else {
        editor.getBody().style.backgroundColor = "#000000";
      }
    },
    toggleName() {
      this.includeName = !this.includeName;
    },
    toggleRoom() {
      this.includeRoom = !this.includeRoom;
    },
    getCorrectTextColor() {
      let hex = this.backgroundColor.hex;
      let threshold = 130; /* about half of 256. Lower threshold equals more dark text on dark background  */

      let hRed = hexToR(hex);
      let hGreen = hexToG(hex);
      let hBlue = hexToB(hex);

      function hexToR(h) {
        return parseInt(cutHex(h).substring(0, 2), 16);
      }
      function hexToG(h) {
        return parseInt(cutHex(h).substring(2, 4), 16);
      }
      function hexToB(h) {
        return parseInt(cutHex(h).substring(4, 6), 16);
      }
      function cutHex(h) {
        return String(h).charAt(0) == "#"
          ? String(h).substring(1, 7)
          : String(h);
      }

      let cBrightness = (hRed * 299 + hGreen * 587 + hBlue * 114) / 1000;
      if (cBrightness > threshold) {
        return "#000000";
      } else {
        return "#ffffff";
      }
    },
    editVisibility(name, value) {
      if (name == "all") {
        this.visibility =
          this.visibility.anonymous &&
          this.visibility.checkin &&
          this.visibility.precheckin
            ? { precheckin: false, checkin: false, anonymous: false }
            : { precheckin: true, checkin: true, anonymous: true };
        this.$emit("editVisibility", this.visibility);
      } else {
        this.visibility[name] = !value;
        this.$emit("editVisibility", this.visibility);
      }
    },
    onSelectedImage(imageUrl) {
      this.imagePath = imageUrl;
    },
    toggleLanguage(indexClicked) {
      this.localLanguageTypesIndex = Number(indexClicked);
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.input-group .h2 {
  margin-top: 24px;
  margin-bottom: 16px;
}

.horizontal-checkbox {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
}

.color-input-wrapper {
  position: relative;
}

.color-indicator {
  width: 28px;
  height: 28px;
  position: absolute;
  z-index: 1;
  top: 8px;
  right: 8px;
  border-radius: var(--border-radius);
  border: 2px solid var(--grey);
}

.colorPickerWrapper {
  position: relative;
}

.colorOuterWrap {
  position: absolute;
  top: 0;
  left: 50%;
  z-index: 1;
  transform: translateX(-50%);
}

.colorInnerWrap button {
  position: absolute;
  bottom: 5px;
  left: 5px;
  background-color: #48b9ba;
  color: #fff;
  cursor: pointer;
  width: 70px;
  height: 25px;
  border: none;
  border-radius: 5px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
  transition: 0.1s ease-in;
}
.colorInnerWrap button:hover {
  background-color: #49a39c;
}
.colorInnerWrap button.closeBtn {
  left: 85px;
  background-color: #894e99;
}

.icon-image-container {
  display: flex;
}

.icon-image-container__radio-container {
  flex-grow: 0;
  flex-shrink: 0;
}

.icon-image-container__radio-container button {
  margin-bottom: 16px;
  width: 180px;
}

.icon-image-container__video,
.icon-image-container__image {
  width: 100%;
  height: 120px;
  display: flex;
  margin-left: 16px;
  background-color: var(--grey-light);
  border-radius: var(--border-radius);
}

.icon-image-container__image img {
  width: 100%;
  border-radius: var(--border-radius);
  object-fit: contain;
}

.icon-image-container__video {
  justify-content: center;
}
</style>
